<template>
  <div ref="target">
    <slot
      :visioned="visioned"
      :visible="visible"
    />
  </div>
</template>
<script setup>
import { ref, watch } from 'vue';
import useElementVisibility from '../../composables/useElementVisibility';

const emit = defineEmits(['visible']);

const target = ref(null);

const { visioned, visible } = useElementVisibility(target);

watch(visible, () => emit('visible', visible.value));

</script>
